module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_3_3.968ea81f.png";